import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';
import { healthSignUpData } from '../../models/auth/healthSignup/healthSignup.model';
import { ACCOUNT, SIGNUP_OTP } from '../../routes/routeConstants';

const useHealthSignup = () => {
  const navigate = useNavigate();
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onSigupSuccess =
    (email: string) =>
    ({ data }: SuccessHttpResponse<any>) => {
      toast.success('Signup successful!', {
        duration: 2000,
      });
      navigate(`/${ACCOUNT}/${SIGNUP_OTP}`, {
        replace: true,
        state: { data: email },
      });
    };

  const onSignUpError = (err: AxiosError<ErrorHttpResponse>) => {
    console.log('onSignUpError');
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const signUpHealth = (data: healthSignUpData) => {
    const url: HttpConfig = {
      url: 'auth-service/institution/signup',
      method: 'post',
      data: {
        institutionName: data.institutionName,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        password: data.password,
        state: data.state,
        city: data.city,
        localGovernment: data.localGovernment,
        serviceIndustry: data.serviceIndustry,
        street: data.street,
        isTermsAccepted: data.isTermsAccepted,
      },
    };

    request(url, onSigupSuccess(data.email), setLoading, onSignUpError);
  };

  return {
    loading,
    signUpHealth,
  };
};

export default useHealthSignup;
